import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/site/Header";
import { Footer, MobileBar } from "@/components/site/Footer";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import Home from "@/pages/Home";
import ServicePage from "@/pages/ServicePage";
import DevisPage from "@/pages/DevisPage";
import Legal from "@/pages/Legal";
import AdminLogin from "@/pages/AdminLogin";
import AdminQuotes from "@/pages/AdminQuotes";
import AdminReviews from "@/pages/AdminReviews";

const Shell = () => {
  const { pathname } = useLocation();
  const admin = pathname.startsWith("/admin");
  return (
    <>
      <SmoothScroll />
      {!admin && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services/:slug" element={<ServicePage />} />
        <Route path="/devis" element={<DevisPage />} />
        <Route path="/mentions-legales" element={<Legal />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/devis" element={<AdminQuotes />} />
        <Route path="/admin/avis" element={<AdminReviews />} />
        <Route path="*" element={<Home />} />
      </Routes>
      {!admin && <Footer />}
      {!admin && <MobileBar />}
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
